import BottomTab from "./bottomTab";
import Header from "./header";

const Page = ({ children, className = "", title, hideBottom }) => {
    return (
        <div className={`page ${className}`}>
            {!hideBottom && <Header title={title} />}
            {children}
            {!hideBottom && <BottomTab />}
        </div>
    );
};
export default Page;
